import React, { Component } from 'react';
import Link from './Link';
import moment from 'moment';

class ArticleModal extends Component {
    render() {
        var article = this.props.article;
        return (
            <div className="pop-modal">
                <div className="pop-header">   
                    <button className="pop-section" onClick={() => {
                        window.location.href = "/"+article.sectionId;
                        this.props.showArticle(null);
                    }}>{article.sectionName}</button>
                    <button className="material-symbols-rounded pop-share" title="Copy article link" onClick={() => this.props.copyLink(article.id)}>ios_share</button>
                </div>
                <h1 className="pop-title">{article.fields.headline}</h1>
                <p className="pop-meta">
                    {moment(article.webPublicationDate).fromNow()}&nbsp;&nbsp;•&nbsp;
                    By {article.fields.byline}&nbsp;&nbsp;•&nbsp;&nbsp;
                    {Math.round((article.fields.wordcount / 10)*0.0769)} mins
                </p>
                <div
                    className="pop-detail"
                    dangerouslySetInnerHTML={{
                        __html: article.fields.body
                            ? article.fields.body.replace(
                                /href\s*=\s*(['"])(https:\/\/www\.theguardian\.com\/[^'"]+)/g,
                                (match, quote, url) => {
                                    const path = url.replace("https://www.theguardian.com/", "");
                                    const slashCount = (path.match(/\//g) || []).length;
                                    if (slashCount >= 3) {
                                        return `href=${quote}${window.location.origin}/${path}`;
                                    }
                                    return match;
                                }
                              )
                            : ""}}
                />
                <h6 className="pop-end">_____</h6>
                {/* <button className="pop-close" onClick={this.props.clearArticle}></button> */}
            </div>
        )
    }
}

ArticleModal.defaultProps = {
	class : ''
}
 
export default ArticleModal;